import { atom } from 'recoil';

export const loadingState = atom({
    key: 'loadingState',
    default: false,
});

export const previousPage = atom({
    key: 'previousPage',
    default: '',
});

export const modalState = atom({
    key: 'modalState',
    default: {
        isOpen: false,
        message: '',
    },
});
